import React, { useState, useEffect } from 'react';

const CustomCursor = () => {
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            // Pas de transition, position directe = 0 lag
            setMousePosition({ x: e.clientX, y: e.clientY });
        };

        const handleMouseOver = (e) => {
            // Détecte si on survole un élément cliquable
            const target = e.target;
            const isClickable =
                target.tagName === 'BUTTON' ||
                target.tagName === 'A' ||
                target.tagName === 'INPUT' ||
                target.getAttribute('role') === 'button' ||
                target.style.cursor === 'pointer' ||
                target.closest('button') ||
                target.closest('a');

            setIsHovering(isClickable);
        };

        window.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseover', handleMouseOver);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseover', handleMouseOver);
        };
    }, []);

    return (
        <>
            <style>{`
        * {
          cursor: none !important;
        }
        
        .custom-pokeball-cursor {
          position: fixed;
          width: 32px;
          height: 32px;
          pointer-events: none;
          z-index: 99999;
          transform: translate(-50%, -50%);
          /* AUCUNE transition sur la position pour 0 lag */
        }
        
        .pokeball-inner {
          width: 100%;
          height: 100%;
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        /* Animation quand on survole un élément cliquable */
        .pokeball-inner.hovering {
          transform: scale(1.3) rotate(20deg);
          animation: pokeball-shake 0.5s ease-in-out infinite;
        }
        
        @keyframes pokeball-shake {
          0%, 100% { transform: scale(1.3) rotate(20deg); }
          25% { transform: scale(1.3) rotate(25deg); }
          75% { transform: scale(1.3) rotate(15deg); }
        }
        
        /* Animation d'ouverture de la Pokéball */
        .pokeball-top {
          transition: transform 0.3s ease;
          transform-origin: bottom center;
        }
        
        .pokeball-bottom {
          transition: transform 0.3s ease;
          transform-origin: top center;
        }
        
        .hovering .pokeball-top {
          transform: rotateX(-30deg);
        }
        
        .hovering .pokeball-bottom {
          transform: rotateX(30deg);
        }
      `}</style>

            <div
                className="custom-pokeball-cursor"
                style={{
                    left: `${mousePosition.x}px`,
                    top: `${mousePosition.y}px`,
                }}
            >
                <div className={`pokeball-inner ${isHovering ? 'hovering' : ''}`}>
                    {/* Pokeball Cursor - Exact replica of header/footer */}
                    <div className="relative w-full h-full" style={{ perspective: '100px' }}>
                        {/* Background gradient */}
                        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-red-600 to-red-700 shadow-2xl"></div>

                        {/* Top half - Red (s'ouvre vers le haut au hover) */}
                        <div className="pokeball-top absolute inset-0 top-0 h-1/2 rounded-t-full bg-red-600 shadow-lg"></div>

                        {/* Bottom half - White (s'ouvre vers le bas au hover) */}
                        <div className="pokeball-bottom absolute inset-0 bottom-0 top-1/2 h-1/2 rounded-b-full bg-white shadow-lg"></div>

                        {/* Middle black line */}
                        <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-900 transform -translate-y-1/2 z-10"></div>

                        {/* Center white circle with black border */}
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white rounded-full border-2 border-gray-900 z-20 shadow-xl"></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomCursor;